<template>
  <div
      v-if="campaignLabel || (banners && banners[0]) || isDiscount || isNew(createdAt)"
      class="w-fit -mt-4 mb-1 h-10 rounded-tl-md font-semibold rounded-br-md -ml-4 px-2.5 py-1.5 text-lg"
      :class="{'bg-secondary-300 text-white': !goodPrice, 'bg-none text-secondary-300': goodPrice}"
  >
    <template v-if="banners && banners[0]">
      {{ __("Kampaania!") }}
    </template>
    <template v-else-if="campaignLabel">
      {{ campaignLabel }}
    </template>
    <template v-else-if="isDiscount">
      <template v-if="goodPrice">
        {{ __("Hea hind") }}
      </template>
      <template v-else>
        {{ __("Soodustus") }} -{{ discountPercent }}%
      </template>
    </template>
    <div v-else class="uppercase">
      {{ __("Uus!") }}
    </div>
  </div>
</template>

<script setup>
import {__, hasDiscount, isNew} from "../utils";
import {computed} from "vue";

const props = defineProps({
  showRibbon: {
    default: true,
    type: Boolean
  },
  createdAt: {
    type: [String, null]
  },
  campaignLabel: {
    type: [String, null]
  },
  banners: {
    type: Array,
    default: () => {
      return [];
    }
  },
  classes: {
    type: String,
    default: null
  },
  goodPrice: {
    type: [Boolean, Number],
    required: true
  },
  priceVat: {
    type: [String, Number],
    required: true
  },
  priceDefaultVat: {
    type: [String, Number],
    required: true
  },
  discountStart: {
    type: String,
    default: null
  },
  discountEnd: {
    type: String,
    default: null
  }
});
const discountPercent = computed(() =>
    Math.round(100 - (props.priceVat / props.priceDefaultVat) * 100)
);
const isDiscount = computed(
    () =>
        props.goodPrice ||
        hasDiscount(
            props.priceVat,
            props.priceDefaultVat,
            props.discountStart,
            props.discountEnd
        )
);
</script>
